import { Button } from "@mui/material";
import { UnitsFieldsSourceType } from "constant/dl_unit/dl_unit_field.constant";
import { QUERY_KEYS } from "constant/react_query";
import { useUnitsFieldsAdd } from "hooks/citajteo/dl_unit/useUnitsFieldsAdd";
import toast from "react-hot-toast";
import styled from "styled-components";
import { UnitFields } from "type/dl_unit/dl_unit.type";

type UnitsFieldsProps = {
  sourceType: UnitsFieldsSourceType | "";
  fields: UnitFields[];
  setFields: React.Dispatch<React.SetStateAction<UnitFields[]>>;
};

const UnitsFields = ({ sourceType, fields, setFields }: UnitsFieldsProps) => {
  const { unitsFieldsAddMutate } = useUnitsFieldsAdd({
    invalidateKeys: [QUERY_KEYS.CITAJTEO_DL_UNIT_SEARCH],
  });

  if (fields.length === 0) {
    return null;
  }

  const fieldsAdd = () => {
    unitsFieldsAddMutate(
      { sourceType, fields },
      {
        onSuccess: (data: any) => {
          console.log(data.msg);
          toast.success("Uspešno dodavanje jedinica.");
          setFields([]);
          // navigate("/admin-dashboard/dl-unit-li");
        },
        onError: (error) => {
          console.error("Error adding units:", error);
          toast.error("Greška prilikom dodavanja jedinica.");
          setFields([]);
        },
      },
    );
  };

  const fieldsAddReset = () => {
    setFields([]);
  };

  return (
    <>
      <div>Za unos {fields.length} jedinica.</div>{" "}
      <DivNav>
        <Button type="button" onClick={fieldsAdd}>
          OK
        </Button>
        <Button onClick={fieldsAddReset} type="button">
          Cancel
        </Button>
      </DivNav>
    </>
  );
};

const DivNav = styled.div`
  margin-top: 2rem;
  display: flex;
  gap: 0.75rem;
`;

export default UnitsFields;
